// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import Etablissement from '@/extend/classes/Etablissement';
import Contrat from '@/extend/classes/Contrat';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Conventions collectives
export default class Convention  {
  // Identifiant unique
  public id: number;
  // code iDCC
  public code: string;
  // Libellé
  public nom: string;
  // Libellé court
  public nomCourt: string;
  // Chèque Intermittents
  public ci: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.nom = '';
    this.nomCourt = '';
    this.ci = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Convention): Convention {
    const newConvention: Convention = new Convention();
    newConvention.id = obj.id;
    newConvention.code = obj.code;
    newConvention.nom = obj.nom;
    newConvention.nomCourt = obj.nomCourt;
    newConvention.ci = obj.ci;
    newConvention.canUpdate = obj.canUpdate;
    newConvention.canDelete = obj.canDelete;
    newConvention.display = obj.display;
    newConvention.notifDefType = obj.notifDefType;
    return newConvention;
  }

  public toJsonConvention (): string {
    const json = {
      code: this.code,
      nom: this.nom,
      nomCourt: this.nomCourt,
      ci: this.ci,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromConvention (obj: Convention): void {
    this.id = obj.id;
    this.code = obj.code;
    this.nom = obj.nom;
    this.nomCourt = obj.nomCourt;
    this.ci = obj.ci;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareConvention (value: Convention): boolean {
    return (this.toJsonConvention() == value.toJsonConvention());
  }

  public cloneConvention (): Convention {
    return Convention.fromJson(this);
  }

  public create (): Promise<Convention> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/conventions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromConvention(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Convention> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/conventions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromConvention(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/conventions/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/conventions/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static brancheList (etablissement: Etablissement): Promise<Convention[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/conventions/brancheList', etablissement, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Convention[] = [];
              res.data.forEach(( a: Convention ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static clauseMiroir (Contrat: Contrat): Promise<Convention[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/conventions/clauseMiroir', Contrat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Convention[] = [];
              res.data.forEach(( a: Convention ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Convention> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Conventions/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Convention.fromJson(listData.reccords[0] as Convention);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(conventions: Convention[]) {
  }
}
